import classnames from 'classnames';
import React from 'react';
import { getIcon } from '../../components/Icons';
import { DownloadableResourceProps, DownloadableResourcesProps } from '../../entities/Resource';
import { DOWNLOADABLES } from '../../utils/constants';
import './DownloadableResources.scss';
import ResourcesSelect from './ResourcesSelect';

export default function DownloadableResources({ downloads, identifier, product }: DownloadableResourcesProps): React.ReactElement {
  //Build list of downloadables from the actual files available
  if (downloads.edges.length === 0 && !identifier) return null;

  const downloadables = DOWNLOADABLES.map((value) => {
    const file = downloads.edges.find((element) => element.node.base.endsWith(value.file));
    const multipleSchematics = downloads.edges.filter((element) => element.node.base.endsWith(value.file) && value.file === 'schematics.pdf');
    if (value.file === 'schematics.pdf' && multipleSchematics.length > 1) {
      return {
        name: value.name,
        file: file.node.publicURL,
        link: null,
        icon: value.icon,
        multipleSchematics: multipleSchematics,
      };
    }
    let link = '';

    /*
     * Datasheet appear only in /resources/datasheets/ to fix CDN problems. So we have todo this check here
     * Will be improved after datasheet renderer removal
     */
    if (!file && value.file !== 'datasheet.pdf') {
      return null;
    }
    let nameIdentifier = null;
    if (value.file === 'datasheet.pdf' && !identifier) {
      if (value.file === 'datasheet.pdf' && file) {
        nameIdentifier = file.node.base.split('-datasheet.pdf')[0];
      } else return null;
    }

    if (value.name === 'Pinout (PDF)') {
      link = `/resources/pinouts/` + file.node.base;
    } else if (value.name === 'Datasheet') {
      const datasheetIdentifier = identifier ? identifier + '-datasheet.pdf' : nameIdentifier + '-datasheet.pdf';
      link = `/resources/datasheets/` + datasheetIdentifier;
    } else if (value.name === 'Schematics') {
      link = `/resources/schematics/` + file.node.base;
    } else if (value.name === 'STEP Files') {
      link = `/resources/models/` + file.node.base;
    } else {
      link = file.node.publicURL;
    }

    return {
      name: value.name,
      file: file?.node?.publicURL,
      link: link,
      icon: value.icon,
    };
    // 'https://docs.arduino.cc/resources/datasheets/' + base
  }).filter((element) => element !== null); // Cleanup list from non-existent links

  // ! Workaround for H7 board - can symlinks work with pdf files?
  if (product.includes('H7') && product !== 'Portenta H7') {
    downloadables.splice(1, 0, {
      name: 'Datasheet',
      file: 'https://docs.arduino.cc/resources/datasheets/ABX00042-ABX00045-ABX00046-datasheet.pdf',
      link: 'https://docs.arduino.cc/resources/datasheets/ABX00042-ABX00045-ABX00046-datasheet.pdf',
      icon: 'IconDatasheet',
    });
  }

  return (
    <div className="resources">
      <div className="resources__title">
        <h2>Downloadable resources</h2>
        <span />
      </div>
      {downloadables.length > 0 && (
        <div className={classnames('resources__items', { 'resources__items--left': downloadables.length < 4 })}>
          {downloadables.map((resource: DownloadableResourceProps) => {
            if (resource.name === 'Schematics' && resource.multipleSchematics) {
              return <ResourcesSelect key={resource.name + ' ' + resource.file} resource={resource} />;
            } else {
              return (
                <a
                  key={resource.name + ' ' + resource.file}
                  href={resource.link}
                  target="_blank"
                  rel="noreferrer"
                  download={resource.name === 'STEP Files'}
                >
                  <span className="resources__icon">{getIcon(resource.icon)}</span>
                  <div className="resources__text">{resource.name}</div>
                </a>
              );
            }
          })}
        </div>
      )}
    </div>
  );
}
